var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7891 18.0317C18.0703 17.726 18.0703 17.2305 17.7891 16.9249C17.5079 16.6193 17.0521 16.6193 16.7709 16.9249L12.72 21.328V0.782608C12.72 0.350385 12.3976 0 12 0C11.6023 0 11.28 0.350385 11.28 0.782608V21.328L7.22912 16.9249C6.94794 16.6193 6.49206 16.6193 6.21088 16.9249C5.92971 17.2305 5.92971 17.726 6.21088 18.0317L11.4909 23.7708C11.7721 24.0764 12.2279 24.0764 12.5091 23.7708L17.7891 18.0317Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.9ec695ded17bcbfcf374a1d3165571da.svg";